type CookieOptions = {
	path?: string;
	domain?: string;
	secure?: boolean;
	sameSite?: 'strict' | 'lax' | 'none';
	maxAge?: number;
	expires?: Date;
};

export const cookieGet = (name: string): string | null => {
	const match = document.cookie.match(new RegExp(`(?:^|; )${encodeURIComponent(name)}=([^;]*)`));
	return match?.[1] ? decodeURIComponent(match[1]) : null;
};

export const cookieSet = (name: string, value: string, options: CookieOptions = {}): void => {
	let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

	if (options.path !== undefined) {
		cookie += `; path=${options.path}`;
	}
	if (options.domain !== undefined) {
		cookie += `; domain=${options.domain}`;
	}
	if (options.secure === true) {
		cookie += '; secure';
	}
	if (options.sameSite !== undefined) {
		cookie += `; samesite=${options.sameSite}`;
	}
	if (options.maxAge !== undefined) {
		cookie += `; max-age=${options.maxAge}`;
	}
	if (options.expires !== undefined) {
		cookie += `; expires=${options.expires.toUTCString()}`;
	}

	document.cookie = cookie;
};

export const cookieRemove = (name: string, path: string = '/'): void => {
	cookieSet(name, '', { path, maxAge: 0 });
};
